<div class="documents">
	<!-- Filtres -->
	<p class="text-[12px] my-1">Sélectionnez un bénéficiaire pour charger ses documents.</p>
	<div class="flex flex-wrap gap-2">
		<!-- Utilisateur principal -->
		<ng-container *ngIf="currentUser?.passportNumber">
			<button class="px-4 py-2 text-[12px] rounded-lg" [ngClass]="{
					'bg-primary text-white': selectedPassport === currentUser?.passportNumber,
					'bg-gray-200 text-gray-700 hover:bg-gray-300': selectedPassport !== currentUser?.passportNumber
				}" (click)="selectPassport(currentUser?.passportNumber)">Vous</button>
		</ng-container>

		<!-- Bénéficiaires passés en input (excluant l'utilisateur connecté) -->
		<ng-container *ngFor="let beneficiary of beneficiaries; trackBy: trackByPassportNumber">
			<ng-container *ngIf="beneficiary.passportNumber !== currentUser?.passportNumber">
				<button class="px-4 py-2 text-[12px] rounded-lg" [ngClass]="{
									'bg-primary text-white': selectedPassport === beneficiary.passportNumber,
									'bg-gray-200 text-gray-700 hover:bg-gray-300': selectedPassport !== beneficiary.passportNumber
								}" (click)="selectPassport(beneficiary.passportNumber)">
					{{ beneficiary.fullname }}
				</button>
			</ng-container>
		</ng-container>
	</div>

	<div class="flex justify-between items-center flex-wrap mt-5">
		<div class="flex items-center gap-x-4">
			<div class="flex items-center gap-x-2">
				<label for="search" class="text-[12px]">Rechercher : </label>
				<input type="text" id="search" [(ngModel)]="searchTerm"
					class="placeholder:text-gray-300 text-[12px] rounded-lg border border-gray-300 w-[300px] p-2"
					placeholder="Rechercher un document" />
			</div>
			<!-- Bouton Filtre Important -->
			<button class="text-[12px] flex items-center gap-1 px-3 py-2 rounded border" [ngClass]="{
					'bg-primary text-white border-primary': showFavoritesOnly,
					'bg-white text-gray-700 border-gray-300 hover:bg-gray-50': !showFavoritesOnly
				}" (click)="toggleFavoritesFilter()">
				<lucide-icon [img]="showFavoritesOnly ? BookmarkCheck : Bookmark" size="16" />
				<span>{{ showFavoritesOnly ? 'Tous les documents' : 'Voir les documents importants' }}</span>
			</button>
		</div>
		<!-- Bouton Ajouter un document (conditionnel) -->
		<ng-container *ngIf="showAddButton">
			<button class="text-[12px] flex items-center gap-1 text-white bg-primary px-3 py-2 rounded"
				(click)="addDocument()">
				<lucide-icon [img]="Plus" size="16" />
				<span>Ajouter un document</span>
			</button>
		</ng-container>
	</div>

	<!-- Tableau des documents du bénéficiaire sélectionné -->

	<div class="overflow-x-auto rounded-lg border border-gray-200 bg-white shadow mt-7 pb-28">
		<ng-container *ngIf="documentsLoading; else notLoading">
			<div class="flex items-center justify-center py-12">
				<div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
				<span class="ml-3 text-gray-600">Chargement des documents...</span>
			</div>
		</ng-container>
		<ng-template #notLoading>
			<ng-container *ngIf="documentsError; else noError">
				<div class="text-center text-red-500 py-4">{{ documentsError }}</div>
			</ng-container>
			<ng-template #noError>
				<ng-container *ngIf="(documentsByPassport || []).length === 0; else showTable">
					<div class="text-center py-12">
						<div class="max-w-md mx-auto">
							<svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24"
								stroke="currentColor">
								<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
									d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
							</svg>
							<h3 class="mt-2 text-sm font-medium text-gray-900">Aucun document</h3>
							<p class="mt-1 text-sm text-gray-500">Aucun document trouvé pour ce bénéficiaire.</p>
						</div>
					</div>
				</ng-container>
				<ng-template #showTable>
					<table class="w-full">
						<thead>
							<tr class="bg-gray-100 border-b border-gray-200">
								<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Type</th>
								<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Nom du fichier</th>
								<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Canal</th>
								<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Date</th>
								<th class="text-left py-3 px-4 text-sm font-semibold text-gray-900">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let doc of filteredDocuments; trackBy: trackById"
								class="hover:bg-gray-50 border-b border-gray-100">
								<td class="py-3 px-4 text-sm text-gray-900">{{ doc.documentType?.label || '-' }}</td>
								<td class="py-3 px-4 text-sm text-gray-900">{{ doc.filename || '-' }}</td>
								<td class="py-3 px-4 text-sm">
									<span class="">{{ doc.source?.label || '-' }}</span>
								</td>
								<td class="py-3 px-4 text-sm text-gray-900">{{ doc.createdAt ? (doc.createdAt |
									date:'dd/MM/yyyy à
									HH:mm') : '-' }}
								</td>
								<td class="py-3 px-4" style="position: relative;">
									<div class="dropdown dropdown-end">
										<div tabindex="0" role="button"
											class="btn btn-ghost btn-xs hover:bg-transparent hover:border-none hover:shadow-none"
											title="Options">
											<lucide-icon class="text-gray-500" [img]="MoreVertical" size="18"></lucide-icon>
										</div>
										<ul tabindex="0"
											class="dropdown-content menu p-2 shadow bg-white border-none rounded-box w-56"
											style="z-index: 9999; position: absolute; right: 0; top: 100%;">
											<li>
												<button (click)="onViewDocument(doc)"
													class="flex items-center gap-2 text-sm">
													<lucide-icon [img]="Eye" size="16"></lucide-icon>
													<span>Visualiser</span>
												</button>
											</li>
											<li>
												<button (click)="onDownloadDocument(doc)"
													class="flex items-center gap-2 text-sm">
													<lucide-icon [img]="Download" size="16"></lucide-icon>
													<span>Télécharger</span>
												</button>
											</li>
											<li>
												<button (click)="toggleFavorite(doc)"
													class="flex items-center gap-2 text-sm"
													[ngClass]="doc.isFavorite ? 'text-primary' : ''">
													<lucide-icon [img]="doc.isFavorite ? BookmarkCheck : Bookmark"
														size="16"></lucide-icon>
													<span>{{ doc.isFavorite ? 'Retirer des importants' : 'Document
														important' }}</span>
												</button>
											</li>
											@if (doc.prestationId) {
											<li>
												<button (click)="viewPrestation(doc.prestationId, doc._id || doc.id)"
													class="flex items-center gap-2 text-sm"
													[disabled]="loadingPrestationForId === (doc._id || doc.id)">
													<span class="loading loading-spinner loading-xs"
														*ngIf="loadingPrestationForId === (doc._id || doc.id)"></span>
													<lucide-icon *ngIf="loadingPrestationForId !== (doc._id || doc.id)"
														[img]="FileText" size="16"></lucide-icon>
													<span>{{ loadingPrestationForId === (doc._id || doc.id) ?
														'Chargement...' : 'Voir la prestation' }}</span>
												</button>
											</li>
											}
										</ul>
									</div>
								</td>
							</tr>
						</tbody>
					</table>

					<!-- Pagination -->
					<ng-container *ngIf="totalPages > 1">
						<div class="flex items-center justify-between mt-6">
							<div class="flex-1 flex justify-between sm:hidden">
								<button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
									class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
									Précédent
								</button>
								<button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
									class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
									Suivant
								</button>
							</div>
							<div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between px-4">
								<div>
									<p class="text-sm text-gray-700">
										Affichage de
										<span class="font-medium">{{ (currentPage - 1) * pageSize + 1 }}</span>
										à
										<span class="font-medium">{{ getMaxItemsOnPage() }}</span>
										sur
										<span class="font-medium">{{ totalItems }}</span>
										résultats
									</p>
								</div>
								<div>
									<nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px">
										<button (click)="goToPreviousPage()" [disabled]="currentPage === 1"
											class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
											<span class="sr-only">Précédent</span>
											<svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
												fill="currentColor">
												<path fill-rule="evenodd"
													d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
													clip-rule="evenodd" />
											</svg>
										</button>
										<button *ngFor="let page of getPaginationArray(); trackBy: trackById"
											(click)="goToPage(page)"
											class="relative inline-flex items-center px-4 py-2 border text-sm font-medium"
											[class]="page === currentPage ? 'z-10 bg-primary-50 border-primary-500 text-primary-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'">
											{{ page }}
										</button>
										<button (click)="goToNextPage()" [disabled]="currentPage === totalPages"
											class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed">
											<span class="sr-only">Suivant</span>
											<svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
												fill="currentColor">
												<path fill-rule="evenodd"
													d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
													clip-rule="evenodd" />
											</svg>
										</button>
									</nav>
								</div>
							</div>
						</div>
					</ng-container>
				</ng-template>
			</ng-template>
		</ng-template>
	</div>
</div>